import { Check, Copy, Share2 } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import { CardDescription, CardTitle } from "@/components/ui/card"

interface ReferralCardProps {
  referralCode: string
  referralsCount: number
}

export function ReferralCard({
  referralCode,
  referralsCount,
}: ReferralCardProps) {
  const [copied, setCopied] = useState(false)

  const referralUrl = `${window.location.origin}/registro?ref=${referralCode}`
  const whatsappMessage = encodeURIComponent(
    `Te invito a ArgentinosMAD, la comunidad de argentinos en Madrid. Registrate con mi codigo y gana 50 puntos de bienvenida: ${referralUrl}`,
  )
  const whatsappUrl = `https://wa.me/?text=${whatsappMessage}`

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralUrl)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error("Failed to copy:", err)
    }
  }

  const handleWhatsAppShare = () => {
    window.open(whatsappUrl, "_blank")
  }

  return (
    <div className="space-y-2 px-4">
      <CardTitle className="flex items-center gap-2 text-lg">
        <Share2 className="text-primary h-5 w-5" />
        Invita amigos y gana puntos
      </CardTitle>
      <CardDescription>
        Comparte tu codigo y gana 100 puntos por cada amigo que se registre. Tu
        amigo tambien gana 50 puntos.
      </CardDescription>
      <p className="text-muted-foreground text-sm">
        Has invitado a{" "}
        <span className="text-foreground font-semibold">{referralsCount}</span>{" "}
        amigo{referralsCount !== 1 ? "s" : ""}
        {referralsCount > 0 && (
          <span className="text-primary">
            {" "}
            (+{referralsCount * 100} pts ganados)
          </span>
        )}
      </p>
      <div className="bg-card flex items-center justify-between rounded-lg border p-3">
        <div>
          <p className="text-muted-foreground text-xs">Tu codigo de referido</p>
          <p className="text-primary font-mono text-xl font-bold">
            {referralCode}
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            void handleCopy()
          }}
          className="gap-2"
        >
          {copied ? (
            <>
              <Check className="h-4 w-4" />
              Copiado
            </>
          ) : (
            <>
              <Copy className="h-4 w-4" />
              Copiar link
            </>
          )}
        </Button>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row">
        <Button
          variant="default"
          className="flex-1 gap-2"
          onClick={handleWhatsAppShare}
        >
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
          Compartir por WhatsApp
        </Button>
      </div>
    </div>
  )
}
